module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_3.bc239762.png";